import * as React from 'react';
import {
  Container,
  Box,
  ListItemText,
  ListSubheader,
  List,
  ListItemButton,
  Typography
} from '@mui/material';
import extractChatMessages from '../helper-methods/fetchAndRefreshMessages';
import useMessagesStore from '../state-files/useMessagesStore';
import { useMediaQuery } from "@mui/system";
import fetchBlockedUsers from '../helper-methods/fetchBlockList';
import Cookies from 'js-cookie'
import { apiUrlPrefix } from '../../../config';
import { useCallback, useRef } from 'react';

const BlockList = ({ selected }) => {
  const [blockList, setBlockList] = React.useState([]);
  const { setMessageList } = useMessagesStore();
  const isMobile = useMediaQuery('(max-width:1300px)');

  React.useEffect(() => {
    const getBlockList = async () => {
      const blockedUsers = await fetchBlockedUsers();
      setBlockList(blockedUsers);
    }
    getBlockList();
  }, []);

  // Keep track of the last fetch time outside of the render cycle
  const lastFetchTime = useRef(0);

  React.useEffect(
    useCallback(() => {
      const refreshBlockList = async () => {
        const blockedUsers = await fetchBlockedUsers();
        setBlockList(blockedUsers);
      }
      const now = Date.now();

      // Only fetch if 5 seconds (5000ms) have passed since the last call
      if (now - lastFetchTime.current > 5000) {
        refreshBlockList();
        lastFetchTime.current = now; // Update the timestamp
      }

      return () => {
        // Optional: Clean up logic if needed when leaving the screen
      };
    }, [selected === 1]) // Dependency array for useCallback
  );


  const unblockUser = async (targetUserId) => {
    const currentUserId = localStorage.getItem('userId');

    const apiUrl = apiUrlPrefix + 'Blocking/UnblockUser';
    const response = await fetch(apiUrl, {
      method: 'PUT',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: currentUserId,
        blockedUserId: targetUserId
      }),
    });
    if (response.ok) {
      return response.status;
    } else if (response.status === 400) {
      return 304; //It is not modified
    }
  }

  return (
    <Box
      className={selected === 1 ? '' : 'hidden'}
      sx={{ flexGrow: 1, padding: 2, width: {xs: '100%', md: '80%'} }}
    >
      <Container>
        <List
          sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: '5px', boxShadow: 1 }}
          component="nav"
          subheader={
            <ListSubheader
              component="div"
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                py: 1,
                borderBottom: '1px solid #eee'
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                Block List
              </Typography>
              <p />

              {/* Place the actual widget here so it can listen for the state change */}

            </ListSubheader>
          }
        >
          {blockList && [...blockList]
            .sort((a, b) => (a.title || "").localeCompare(b.title || ""))
            .map((blockedUser, index) => (
              <ListItemButton key={blockedUser.id || index} onClick={async () => {
                unblockUser(blockedUser.id);
                const blockedUsers = await fetchBlockedUsers();
                setBlockList(blockedUsers);
              }}>
                <ListItemText
                  primary={blockedUser.name || "Unknown"}
                  sx={{ textAlign: 'left' }}
                />
                <ListItemText
                  primary={"Unblock"}
                  sx={{ cursor: 'pointer', justifyContent: 'space-between', color: 'red', textAlign: 'right' }}
                />
              </ListItemButton>
            ))
          }
        </List>
      </Container>
    </Box>
  );
};

export default BlockList;